import React from 'react';
import { Colors } from '../../themes/Colors';
import { translate } from '../../helper';

export default function PaymentMethodInfo({ style = {} }) {
  return (
    <div style={{ width: '100%', ...style }}>
      <div style={{ marginTop: 'var(--sp-md2)', marginBottom: 'calc(var(--sp-xxs) * 2)' }}>
        <span style={{ color: Colors.green, fontWeight: 600, fontSize: 'calc(var(--fs-xs) * 1.4150943)' }}>
          * {translate('defaultPaymentMethodInfo', 'The default payment method will be charged for your subscription.')}
        </span>
      </div>
      <div style={{ marginBottom: 'var(--sp-md2)' }}>
        <span style={{ color: Colors.red, fontWeight: 500, fontSize: 'calc(var(--fs-xs) * 1.4150943)' }}>
          * {translate('cardFeeInfo_prefix', 'If you choose a credit or debit card instead of a bank account, an extra ')}
          <b><em>2.9%</em></b>
          {translate('cardFeeInfo_suffix', ' fee will be added to your subscription price.')}
        </span>
      </div>
    </div>
  );
}
